import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXCMAInquiry implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxCMAInquiryContainer";
    }
    render(){
        // console.log("inquiry");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxCMAInquiryContainer", "firstName", "local_lead_first_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxCMAInquiryContainer", "lastName", "local_lead_last_name");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxCMAInquiryContainer", "phone", "local_lead_phone");
        this.zidx.zidxBase.setFieldFromLocalStorage(".zidxCMAInquiryContainer", "email", "local_lead_email");
    }
}